import { Target, Users, Search, Handshake, ArrowRight } from "lucide-react";

export default function RecruitmentPhilosophy() {
  return (
    <section
      className="w-full py-20 md:py-28 lg:py-32"
      style={{ backgroundColor: "#ffffff" }}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        
        {/* Heading Section - Full width at top */}
        <div className="mb-12">
          {/* Bubble tag matching intro section */}
          <div className="inline-flex items-center gap-2 mb-4">
            <div className="w-2 h-2 bg-black rounded-full"></div>
            <p 
              className="text-sm font-medium uppercase tracking-wider m-0"
              style={{ 
                fontFamily: '"Open Sans", sans-serif',
                fontSize: '14px',
                fontWeight: 500,
                color: '#081120'
              }}
            >
              Our Core Belief
            </p>
          </div>

          {/* Main Heading */}
          <h2
            className="text-3xl md:text-4xl lg:text-5xl font-semibold leading-tight mb-5"
            style={{ 
              fontFamily: 'Outfit, sans-serif',
              fontWeight: 600,
              color: '#081120'
            }}
          >
            Recruitment Isn't Just About Filling Positions.
          </h2>

          {/* Highlighted subheading */}
          <p
            className="text-xl md:text-2xl font-semibold mb-5"
            style={{ 
              fontFamily: 'Outfit, sans-serif',
              fontSize: '22px',
              fontWeight: 600,
              color: '#0058a9'
            }}
          >
            It's About Finding the Right People.
          </p>

          {/* Description paragraph */}
          <p
            className="text-base leading-relaxed"
            style={{ 
              fontFamily: '"Open Sans", sans-serif',
              fontSize: '16px',
              lineHeight: '180%',
              color: '#555658'
            }}
          >
            At Kapil Tech, we combine deep technical expertise with proven recruitment methodologies 
            to deliver the talent your team needs.
          </p>
        </div>

        {/* Split layout: Feature Points left | Image right - aligned together */}
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          
          {/* Left Side - Feature Points */}
          <div className="space-y-6">
            {/* Point 1 */}
            <div className="flex gap-4 group">
              <div className="flex-shrink-0">
                <div className="w-10 h-10 rounded-lg flex items-center justify-center transition-all duration-300 group-hover:scale-110" style={{ backgroundColor: '#f0f2f5' }}>
                  <Target className="w-5 h-5" style={{ color: '#0058a9' }} />
                </div>
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-1" style={{ fontFamily: 'Outfit, sans-serif', color: '#081120' }}>
                  Deep Technical Vetting
                </h3>
                <p className="text-sm leading-relaxed" style={{ color: '#555658' }}>
                  Every candidate undergoes rigorous technical assessments, live coding challenges, 
                  and architecture reviews by domain experts.
                </p>
              </div>
            </div>

            {/* Point 2 */}
            <div className="flex gap-4 group">
              <div className="flex-shrink-0">
                <div className="w-10 h-10 rounded-lg flex items-center justify-center transition-all duration-300 group-hover:scale-110" style={{ backgroundColor: '#f0fdfa' }}>
                  <Search className="w-5 h-5" style={{ color: '#0d9488' }} />
                </div>
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-1" style={{ fontFamily: 'Outfit, sans-serif', color: '#081120' }}>
                  Culture & Fit Matching
                </h3>
                <p className="text-sm leading-relaxed" style={{ color: '#555658' }}>
                  Beyond skills, we evaluate communication, collaboration, and alignment with 
                  your company values for long-term success.
                </p>
              </div>
            </div>

            {/* Point 3 */}
            <div className="flex gap-4 group">
              <div className="flex-shrink-0">
                <div className="w-10 h-10 rounded-lg flex items-center justify-center transition-all duration-300 group-hover:scale-110" style={{ backgroundColor: '#fff2e6' }}>
                  <Handshake className="w-5 h-5" style={{ color: '#ff7a01' }} />
                </div>
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-1" style={{ fontFamily: 'Outfit, sans-serif', color: '#081120' }}>
                  End-to-End Recruitment Support
                </h3>
                <p className="text-sm leading-relaxed" style={{ color: '#555658' }}>
                  From crafting role specs to onboarding, our dedicated recruitment managers 
                  ensure a seamless, transparent process.
                </p>
              </div>
            </div>
          </div>

          {/* Right Side - Image (aligned with feature points) */}
          <div className="relative sticky top-8">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://ik.imagekit.io/7wqj9br0b/KapilTech_Website_Staffing/Home/businesspeople-standing-together-office.jpg"
                alt="Kapil Tech recruitment team collaborating"
                className="w-full h-auto object-cover transition-all duration-700 hover:scale-105"
                loading="lazy"
                onError={(e) => {
                  e.currentTarget.src = "https://placehold.co/800x600/eef2f6/081120?text=Team+Collaboration";
                }}
              />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}